import domain from '@/http/requests/domain'

export default {
  fetch({ commit }, data) {
    return new Promise(
      (resolve, reject) => {
        domain.fetch(data.sortName, data.page, data.itemsPerPage, data.type, data.word).then(
          response => {
            commit('SET_DOMAINS', response.data.data.getDomains);
            resolve(response);
          }
        ).catch( exception => reject(exception) );
      }
    )
  },
  create({ commit }, name) {
    return new Promise(
      (resolve, reject) => {
        domain.create(name).then(
          response => {
            commit('CREATE_DOMAIN', response.data.data.createDomain);
            resolve(response);
          }
        ).catch( exception => reject(exception) );
      }
    )
  },
  delete({ commit }, name) {
    return new Promise(
      (resolve, reject) => {
        domain.delete(name).then(
          response => {
            commit('DELETE_DOMAIN', name);
            resolve(response);
          }
        ).catch( exception => reject(exception) );
      }
    );
  },
  auth(_, name) {
    return new Promise(
      (resolve, reject) => {
        domain.auth(name).then(
          response => resolve(response.data.data.authDomain)
        ).catch( exception => reject(exception) );
      }
    )
  },
  validate(_, name) {
    return new Promise(
      (resolve, reject) => {
        domain.validate(name).then(
          response => resolve(response.data.data.validateDomain)
        ).catch( exception => reject(exception) );
      }
    )
  }
}
